module.exports = new __parcel__URL__("nuage.cb5005d5.svg").toString();